import React from "react";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import Header from "../../Components/Header";
import FNUParent from "../../Components/FreezeUnfreezeCom/FNUParent";

function FreezeUnfreezePage() {
  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="freezeUnfreezeWrapper">
          <FNUParent />
        </div>
      </main>
    </>
  );
}

export default FreezeUnfreezePage;
